export const PurchasedSubscribeStatus = {
    READY_TO_ACTIVE:"آماده فعال سازی",
    PROCESSING:"درحال عملیات",
    ACTIVE:"فعال",
    EXPIRE:"منقضی",
    COMPLETE:"تکمیل",
    CANCEL:"لغو",
    REFUNDED:"بازپرداخت شده",
}
